import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal } from "react-bootstrap";
export default function ModalSuccessCustom(_param) {
    var navigate = _param.navigate, show = _param.show, direction = _param.direction, props = _object_without_properties(_param, [
        "navigate",
        "show",
        "direction"
    ]);
    var handleCloseAndNavigate = function() {
        props.onHide();
        if (direction) {
            navigate(direction);
        }
    };
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "sm",
        centered: true,
        show: show,
        onHide: handleCloseAndNavigate,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "px-3 py-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "84",
                            height: "83",
                            viewBox: "0 0 84 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "mx-auto",
                            children: [
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "42",
                                    cy: "41.5",
                                    r: "41.5",
                                    fill: "#2DC76D"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M56.0123 30.9902L36.7444 50.2581L27.9863 41.5",
                                    stroke: "white",
                                    strokeWidth: "5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fs-18 tc-7",
                        children: props.textsuccess
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mt-4",
                        children: /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-dg px-4",
                            onClick: handleCloseAndNavigate,
                            children: "ปิด"
                        })
                    })
                ]
            })
        })
    }));
}
